import Vue from 'vue'
import Router from 'vue-router'

const MyRoot = () => import(/* webpackChunkName: 'root' */ '@/views/MyRoot') //根文件
const Home = () => import(/* webpackChunkName: 'root' */ '@/views/Home')
// const Home1 = () => import(/* webpackChunkName: 'root' */ '@/views/Home1')
// const Home2 = () => import(/* webpackChunkName: 'root' */ '@/views/Home2')
const Search = () => import(/* webpackChunkName: 'root' */ '@/views/Search')
const Agency = () => import(/* webpackChunkName: 'root' */ '@/views/Agency')
const Schedule = () => import(/* webpackChunkName: 'root' */ '@/views/Schedule')
const Center = () => import(/* webpackChunkName: 'root' */ '@/views/Center')
const CenterLogin = () => import(/* webpackChunkName: 'root' */ '@/views/CenterLogin')



const Euro2024 =() => import('@/views/Euro2024')
const Cup2026 =() => import('@/views/Cup2026')
const Login =() => import('@/views/Login')
const LoginWx =() => import('@/views/LoginWx')
const LostPassword =() => import('@/views/LostPassword')
const WxLogin =() => import('@/views/WxLogin')
const LoginMobile =() => import('@/views/LoginMobile')
const Wxin =() => import('@/views/Wxin')
const Register =() => import('@/views/Register')
const Download =() => import('@/views/Download')
const About =() => import('@/views/About')
const Setting =() => import('@/views/Setting')
const Support =() => import('@/views/Support')
const Supportview =() => import('@/views/Supportview')
const Contact =() => import('@/views/Contact')
const More =() => import('@/views/More')
const Drawontips =() => import('@/views/Drawontips')
const Football =() => import('@/views/Football')
const Basketball =() => import('@/views/Basketball')
const Big5league =() => import('@/views/Big5league')
const Follow =() => import('@/views/Follow')
const Tipsview =() => import('@/views/Tipsview')
const Database =() => import('@/views/Database')
const DatabaseList =() => import('@/views/DatabaseList')
const DatabaseMath =() => import('@/views/DatabaseMath')
const RankDay =() => import('@/views/RankDay')
const WeekRank =() => import('@/views/WeekRank')
const News =() => import('@/views/News')
const NewsList =() => import('@/views/NewsList')
const Newsview =() => import('@/views/Newsview')
const Shop =() => import('@/views/Shop')
const Shoplist =() => import('@/views/Shoplist')
const Shopview =() => import('@/views/Shopview')
const Shoporder =() => import('@/views/Shoporder')
const Centerinfo =() => import('@/views/Centerinfo')
const Centergold =() => import('@/views/Centergold')
const Centertips =() => import('@/views/Centertips')
const Centermagic =() => import('@/views/Centermagic')
const Centerdistribution =() => import('@/views/Centerdistribution')
const CenterUsername =() => import('@/views/CenterUsername')
const CenterPassword =() => import('@/views/CenterPassword')
const CenterMyalipay =() => import('@/views/CenterMyalipay')
const CenterEmail =() => import('@/views/CenterEmail')
const CenterPay =() => import('@/views/CenterPay')
const CenterPayOther =() => import('@/views/CenterPayOther')
const CenterSelltips =() => import('@/views/CenterSelltips')
const CenterBuytips =() => import('@/views/CenterBuytips')
const Users =() => import('@/views/Users')
const Promotion =() => import('@/views/Promotion')
const Apply =() => import('@/views/Apply')
const CenterMobile =() => import('@/views/CenterMobile')
const Success =() => import('@/views/Success')
const Arena =() => import('@/views/Arena')
const ArenaNew =() => import('@/views/ArenaNew')
const ArenaAward =() => import('@/views/ArenaAward')
const ArenaPublish =() => import('@/views/ArenaPublish')
const Tips =() => import('@/views/Tips')
const List =() => import('@/views/List')
const CenterWxbind =() => import('@/views/CenterWxbind')
const Payfail =() => import('@/views/Payfail')
const Winning =() => import('@/views/Winning')
const Radio =() => import('@/views/Radio')
const Special =() => import('@/views/Special')

// Redirected when going from “/a” to “/b” via a navigation guard.报错的解决办法
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
//处理history URL模式问题
let mode = 'history';
const WAY = process.env.WAY;
if (WAY == 'android') {
  mode = 'hash';
}
export default new Router({
  mode: mode,
  routes: [{
      path: '/',
      redirect: '/home',
    },
    {
      // 根页面 
      path: '/myroot',
      name: 'MyRoot',
      component: MyRoot,
      children: [
        //   {
        //   path: '/myroot',
        //   redirect: '/home',
        // },
        {
          path: '/home',
          name: 'Home',
          component: Home,
          meta: { requireAuth: false,  keepAlive: true}
        }, 
        // {
        //   path: '/home1',
        //   name: 'Home1',
        //   component: Home1,
        //   meta: { requireAuth: false,  keepAlive: true}
        // },{
        //   path: '/home2',
        //   name: 'Home2',
        //   component: Home2,
        //   meta: { requireAuth: false,  keepAlive: true}
        // },  
        {
          path: '/database',
          name: 'Database',
          component: Database,
          meta: { title: '资料库', keepAlive: true  }
        },

        {
          path: '/agency',
          name: 'Agency',
          component: Agency,
          meta: { title: '机构',  keepAlive: true}
        },

        {
          path: '/schedule',
          name: 'Schedule',
          component: Schedule,
          meta: { title: '赛程赛果',  keepAlive: true }
        },
        {
          path: '/center',
          name: 'Center',
          component: Center,
          meta: { title: '用户中心',  keepAlive: true}
        },
        {
          path: '/CenterLogin',
          name: 'CenterLogin',
          component: CenterLogin,
          meta: { title: '用户中心',  keepAlive: true }
        }

      ]
    },
    {
      path: '/search/:q?/:sport?',
      name: 'Search',
      component: Search,
      //requireAuth: true,
      meta: { title: '搜索',  keepAlive: true }
    }, 

    {
      path: '/tips/:sport?/:type?/:page1?/:page2?', //兼容SEO翻页 :page1?/:page2? 例子：newsList/1/31/page/2
      name: 'Tips',
      component: Tips,
      meta: { title: '推介列表', keepAlive: true}
      //, requireAuth: true
    },
    {
      path: '/euro2024',
      name: 'Euro2024',
      component: Euro2024,
      meta: { title: '欧洲杯', keepAlive: true}
    },
    {
      path: '/cup2026',
      name: 'Cup2026',
      component: Cup2026,
      meta: { title: '世界杯', keepAlive: true}
    },

    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { title: '用户名登录' }
    },
    {
        path: '/loginWx/:type?',
        name: 'LoginWx',
        component: LoginWx,
        meta: { title: '账号绑定' }
    },
      //CenterWxbind

    {
      path: '/centerWxbind',
      name: 'CenterWxbind',
      component: CenterWxbind,
      meta: { title: '微信绑定' }
    },
    {
      path: '/drawontips',
      name: 'Drawontips',
      component: Drawontips,

    },
    {
      path: '/wxLogin/:unionid/:openid/:nickname/:url_type/:code?',
      name: 'WxLogin',
      component: WxLogin
    },
    {
      path: '/centerMobile',
      name: 'CenterMobile',
      component: CenterMobile,
      meta: { title: '验证手机' }

    },
    {
      path: '/loginMobile',
      name: 'LoginMobile',
      component: LoginMobile,
      meta: { title: '手机登录' }

    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { title: '注册' }
      //meta: {title:'注册' ,keepAlive: true }
    },
    {
      path: '/centerinfo',
      name: 'Centerinfo',
      component: Centerinfo,
      meta: { title: '我的资料' }
    },
    {
      path: '/centergold',
      name: 'Centergold',
      component: Centergold,
      meta: { title: '金豆明细', keepAlive: true }
    },
    {
      path: '/centertips',
      name: 'Centertips',
      component: Centertips,
      meta: { title: '推介中心', keepAlive: true }
    },
    {
      path: '/follow',
      name: 'Follow',
      component: Follow,
      meta: { title: '我的关注'}
    },
    {
      path: '/centermagic',
      name: 'Centermagic',
      component: Centermagic,
      meta: { title: '我的道具', keepAlive: true }
    },
    {
      path: '/centerdistribution',
      name: 'Centerdistribution',
      component: Centerdistribution,
      meta: { title: '分销商', keepAlive: true }
    },
    {
      path: '/centerPassword',
      name: 'CenterPassword',
      component: CenterPassword,
      meta: { title: '修改密码' }
    },
    {
      path: '/lostPassword/:uid?/:key?',
      name: 'LostPassword',
      component: LostPassword,
      meta: { title: '找回密码' }
    },
    {
      path: '/centerMyalipay',
      name: 'CenterMyalipay',
      component: CenterMyalipay,
      meta: { title: '我的提现账号' }
    },
    {
      path: '/centerEmail',
      name: 'CenterEmail',
      component: CenterEmail,
      meta: { title: '邮箱验证' }
    },
    {
      path: '/centerPay',
      name: 'CenterPay',
      component: CenterPay,
      meta: { title: '会员充值'}
    },
    {
      path: '/centerPayOther/:orderid/:qrcode/:realprice/:payname?/:type?',
      name: 'CenterPayOther',
      component: CenterPayOther,
      meta: { title: '会员充值'}
    },
    {
      path: '/centerBuytips',
      name: 'CenterBuytips',
      component: CenterBuytips,
      meta: { title: '我的查看' }
    },
    {
      path: '/centerSelltips',
      name: 'CenterSelltips',
      component: CenterSelltips,
      meta: { title: '我的售出' }
    },
    {
      path: '/users/:uid/:sport?',
      name: 'Users',
      component: Users,
      meta: { title: '个人主页', keepAlive: true}
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '/download',
      name: 'Download',
      component: Download,
      meta: { title: '客户端下载' }
    },

    {
      path: '/about',
      name: 'About',
      component: About,
      meta: { title: '关于我们' }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: { title: '联系我们' }
    },
    {
      path: '/support',
      name: 'Support',
      component: Support,
      meta: { title: '帮助中心' }
    },
    {
      path: '/more',
      name: 'More',
      component: More,
      meta: { title: '设置' }
    },
    {
      path: '/supportview/:id',
      name: 'Supportview',
      component: Supportview,
      meta: { title: '帮助中心' }
    },
    {
      path: '/wxin',
      name: 'Wxin',
      component: Wxin,
      meta: { title: '关注微信公众号' }
    },
    {
        path: '/rankDay/:day?/:sport?',
        name: 'RankDay',
        component: RankDay,
        meta: { title: '排行榜', keepAlive: true }
    },
    // {
    //   path: '/RankKeepwin',
    //   name: 'RankKeepwin',
    //   component: RankKeepwin
    // },
    {
      path: '/football/:type?',
      name: 'Football',
      component: Football,
      meta: { title: '足球推介', keepAlive: true }
    },
    {
      path: '/basketball/:type?',
      name: 'Basketball',
      component: Basketball,
      meta: { title: '篮球推介', keepAlive: true }
      //,requireAuth: true
    },
    {
      path: '/weekRank',
      name: 'WeekRank',
      component: WeekRank,
      meta: { title: '擂台周榜' }
    },
    {
      path: '/big5league/:type?', //:type? 兼容seo路径
      name: 'Big5league',
      component: Big5league,
      meta: { title: '五大联赛', keepAlive: true}
    },

    {
      path: '/promotion/:url?',
      name: 'Promotion',
      component: Promotion,
      meta: { title: '优惠活动' }
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Shop,
      meta: { title: '推介网商城', keepAlive: true }
    },
    {
      path: '/shoplist',
      name: 'Shoplist',
      component: Shoplist,
      meta: { title: '商品列表', keepAlive: true}
    },
    {
      path: '/Shoporder/:id',
      name: 'Shoporder',
      component: Shoporder,
      meta: { title: '确认订单' }
    },
    {
      path: '/shopview/:id',
      name: 'Shopview',
      component: Shopview,
      meta: { title: '产品详情' }
    },

    // {
    //   path: '/package',
    //   name: 'Package',
    //   component: Package
    // },
    // {
    //   path: '/tipslist',
    //   name: 'Tipslist',
    //   component: Tipslist,
    //   meta:{requireAuth:false}
    // },
    // {
    //   path: '/userlist',
    //   name: 'Userlist',
    //   component: Userlist,
    //   meta:{requireAuth:false}
    // },

    // {
    //   path: '/search/:q?/:sport?',
    //   name: 'Search',
    //   component: Search,
    //  // meta: {title:'搜索' }
    //   meta: {title:'搜索' ,keepAlive: true }

    // },
    {
      path: '/tipsview/:id',
      name: 'Tipsview',
      component: Tipsview,
      meta: { title: '推介详情'}
    },
    {
      path: '/centerUsername',
      name: 'CenterUsername',
      component: CenterUsername
    },
//为了兼容公众号旧文章,新增一个页面news_view
    {
      path: '/news',
      name: 'News',
      component: News,
      meta: { title: '球坛资讯' }
    },
    {
      path: '/newsview/:id',
      name: 'Newsview',
      component: Newsview,
      meta: { title: '资讯详情' }
    },
    {
      path: '/news_view/:id',
      name: 'News_view',
      component: Newsview,
      meta: { title: '资讯详情' }
    },
    {
      path: '/newsList/:sport?/:tagid?/:page1?/:page2?', //兼容SEO翻页 :page1?/:page2? 例子：newsList/1/31/page/2
      name: 'NewsList',
      component: NewsList,
      meta: { title: '资讯列表'}
    },

    {
      path: '/databaseList/:id/:sport/:name?',
      name: 'DatabaseList',
      component: DatabaseList,
      meta: { title: '资料库' }
    },
/*     {
      path: '/databaseRanking/:id',
      name: 'DatabaseRanking',
      component: DatabaseRanking,
      meta: { title: '积分榜' }
    }, */
    {
      path: '/databaseMath/:id/:sport/:name?',
      name: 'DatabaseMath',
      component: DatabaseMath,
      meta: { title: '赛程' }
    },
/*     {
      path: '/databaseHandicap/:id',
      name: 'DatabaseHandicap',
      component: DatabaseHandicap,
      meta: { title: '让球' }
    }, */
/*     {
      path: '/databaseHalffull/:id',
      name: 'DatabaseHalffull',
      component: DatabaseHalffull,
      meta: { title: '半全场' }
    }, */

    {
      path: '/success',
      name: 'Success',
      component: Success,
      meta: { title: '支付成功' }

    },
    {
      path: '/payfail',
      name: 'Payfail',
      component: Payfail,
      meta: { title: '支付失败' }

    },
    {
      path: '/apply',
      name: 'Apply',
      component: Apply
    },
    {
      path: '/arena',
      name: 'Arena',
      component: Arena,
      meta: { title: '竞猜擂台', keepAlive: true, requireAuth: true }
    },
    {
      path: '/arenanew',
      name: 'ArenaNew',
      component: ArenaNew,
      meta: { title: '竞猜擂台', keepAlive: true, requireAuth: true }
    },

      //sport:sport,vs_id:v.id,league:v.league,time:v.time,team1:v.team1,team2:v.team2,hdp:v.goal,type:'12',pick:'o'
    {
      path: '/arenaPublish/:sport/:vs_id/:league/:time/:team1/:team2/:hdp/:type/:pick/:max_price?',
      name: 'ArenaPublish',
      component: ArenaPublish,
      meta: { title: '发布竞猜',requireAuth: true }
    },
    {
      path: '/arenaAward',
      name: 'ArenaAward',
      component: ArenaAward,
      meta: { title: '竞猜擂台', keepAlive: true }
    },
    {
      path: '/list',
      name: 'List',
      component: List,
      meta: { title: '世界杯推介', keepAlive: true}
    },
    {
      path: '/winning',
      name: 'Winning',
      component: Winning,
      meta: { title: '游戏奖励', requireAuth: true}
    },
    {
      path: '/radio/:id?',
      name: 'Radio',
      component: Radio,
      meta: { title: '电台推介', keepAlive: true}
    },
    {
      path: '/special',
      name: 'Special',
      component: Special,
      meta: { title: '特色网站', keepAlive: true}
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js